import {
  GET_ORDERS,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_ERROR,
  GET_ORDER,
  GET_ORDER_SUCCESS,
  GET_ORDER_ERROR,
  GET_ORDER_HISTORY,
  GET_ORDER_HISTORY_SUCCESS,
  GET_ORDER_HISTORY_ERROR,
  TOGGLE_ORDER_HISTORY_MODAL,
} from "./actionTypes";

export const getOrders = (request) => {
  return {
    type: GET_ORDERS,
    payload: { request },
  };
};

export const getOrdersSuccess = (orders) => {
  return {
    type: GET_ORDERS_SUCCESS,
    payload: orders,
  };
};

export const getOrdersError = (message) => {
  return {
    type: GET_ORDERS_ERROR,
    payload: message,
  };
};

export const getOrder = (id) => {
  return {
    type: GET_ORDER,
    payload: { id },
  };
};

export const getOrderSuccess = (order) => {
  return {
    type: GET_ORDER_SUCCESS,
    payload: order,
  };
};

export const getOrderError = (message) => {
  return {
    type: GET_ORDER_ERROR,
    payload: message,
  };
};

export const getOrderHistory = (id) => {
  return {
    type: GET_ORDER_HISTORY,
    payload: { id },
  };
};

export const getOrderHistorySuccess = (order) => {
  return {
    type: GET_ORDER_HISTORY_SUCCESS,
    payload: order,
  };
};

export const getOrderHistoryError = (message) => {
  return {
    type: GET_ORDER_HISTORY_ERROR,
    payload: message,
  };
};

export const toggleOrderHistoryModal = () => {
  return {
    type: TOGGLE_ORDER_HISTORY_MODAL,
  };
};
